import HelperText from 'components/HelperText';
import styled from 'styled-components';

export const Content = styled.div`
  padding: 16px;
`;
export const InputContainer = styled.div`
  margin-bottom: 16px;
`;

export const SubmitButtonContainer = styled.div`
  max-width: 180px;
  margin-left: ${({ theme }) => {
    const alignment =
      theme.configs?.styling?.searchForm?.buttonAlignment || 'center';
    if (alignment === 'left') return '0';
    if (alignment === 'right') return 'auto';
    return 'auto'; // center
  }};
  margin-right: ${({ theme }) => {
    const alignment =
      theme.configs?.styling?.searchForm?.buttonAlignment || 'center';
    if (alignment === 'left') return 'auto';
    if (alignment === 'right') return '0';
    return 'auto'; // center
  }};
`;

export const ErrorMessage = styled(HelperText)`
  text-align: center;
  display: block;
  margin-bottom: 16px;
`;
